import React from 'react';
import { Icon } from '../ui';
import fullLogo from '../../assets/full_logo.png';

const links = [
  { label: 'Centre d\'aide', href: '#' },
  { label: 'Documentation', href: '#' },
  { label: 'État du service', href: '#' },
  { label: 'API Développeurs', href: '#' },
];

const legal = ['Mentions Légales', 'Confidentialité', 'CGU', 'Certifications'];

export default function Footer() {
  return (
    <footer className="border-t border-slate-800/50 pt-20 pb-10 bg-gradient-to-b from-transparent to-slate-900/30 rounded-3xl -mx-6 lg:-mx-8 px-6 lg:px-8 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-4 gap-12 mb-16">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-4 mb-8">
              <div className="bg-white p-2 rounded-2xl shadow-xl">
                <img src={fullLogo} alt="AccountInTime" className="h-8 w-auto object-contain" />
              </div>
              <div>
                <span className="text-3xl font-bold bg-gradient-to-r from-white to-slate-200 bg-clip-text text-transparent">AccountInTime</span>
                <p className="text-sm text-indigo-400 uppercase tracking-wider font-semibold mt-1">Enterprise Solution</p>
              </div>
            </div>
            <p className="text-slate-400 text-lg max-w-xl leading-relaxed">
              L'infrastructure digitale de confiance pour les experts comptables modernes en Tunisie.
              <span className="block mt-2 text-slate-300">Sécurité maximale, conformité certifiée, performance exceptionnelle.</span>
            </p>
          </div>

          <div className="lg:col-span-2 grid grid-cols-2 gap-8">
            <div>
              <h4 className="text-white font-bold mb-6">Nous Contacter</h4>
              <ul className="space-y-4 text-slate-400 text-sm">
                <li className="flex items-start gap-3">
                  <Icon name="IconPhone" size={18} className="text-indigo-500 mt-0.5 flex-shrink-0" />
                  <div className="flex flex-col">
                    <a href="tel:+21651491800" className="hover:text-white transition-colors">+216 51 491 800</a>
                    <a href="tel:+21673484150" className="hover:text-white transition-colors">+216 73 484 150</a>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <Icon name="IconMail" size={18} className="text-indigo-500 mt-0.5 flex-shrink-0" />
                  <div className="flex flex-col space-y-1">
                    <a href="mailto:admin@accountintime.tn" className="hover:text-white transition-colors">admin@accountintime.tn</a>
                    <a href="mailto:contact@accountintime.tn" className="hover:text-white transition-colors">contact@accountintime.tn</a>
                    <a href="mailto:support@contactintime.tn" className="hover:text-white transition-colors">support@contactintime.tn</a>
                  </div>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-bold mb-6">Support</h4>
              <ul className="space-y-4 text-slate-400">
                {links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="hover:text-white cursor-pointer transition-colors">{l.label}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800/50 pt-10 flex flex-col lg:flex-row justify-between items-center gap-6">
          <p className="text-slate-500 text-sm">
            &copy; 2026 AccountInTime. Tous droits réservés.
            <span className="block lg:inline lg:ml-2 mt-1 lg:mt-0 text-slate-600">Solution homologuée ANCE</span>
          </p>
          <div className="flex gap-8 text-sm">
            {legal.map((item) => (
              <span key={item} className="text-slate-500 hover:text-white cursor-pointer transition-colors duration-300 hover:scale-105">
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
